import { makeStyles, Theme } from "@material-ui/core";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import { Form, Formik } from "formik";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { FormikPasswordField, FormikTextField } from "../../../components/form/Formik";
import FormError from "../../../components/form/Formik/FormError";
import { FormikSubmitButton } from "../../../components/form/Formik/FormikSubmitButton";
import { getSignUpUrl } from "../../../utils/hubRoutes";
import { Layout } from "../../components/Layout";
import { PageHelmet } from "../../components/PageHelmet";
import { useLoginPasswordPage } from "./useLoginPasswordPage";

const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrapper: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    maxWidth: "100%",
    gap: 10,
    flexGrow: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  button: {
    alignSelf: "center",
    marginTop: 10,
    [theme.breakpoints.up("xs")]: {
      marginTop: 6,
    },
  },
  linkBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 22,
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 24,
    fontWeight: 600,
    [theme.breakpoints.up("xs")]: {
      gap: 10,
    },
  },
  signUpLink: {
    marginLeft: 6,
  },
}));

export const LoginPasswordPage = () => {
  const { initialValues, locale, validationSchema, onPasswordLogin, sendSignUpClickEvent, sendForgotClickEvent } =
    useLoginPasswordPage();
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Layout title={formatMessage({ id: "login.welcome" })}>
      <PageHelmet path="login-password" />
      <Formik onSubmit={onPasswordLogin} initialValues={initialValues} validationSchema={validationSchema}>
        <Form className={classes.form}>
          <FormikTextField
            fullWidth
            name="email"
            placeholder="name@email-address.com"
            label={formatMessage({ id: "common.email" })}
            InputLabelProps={{ shrink: true }}
          />
          <FormikPasswordField
            fullWidth
            name="password"
            InputLabelProps={{ shrink: true }}
            label={formatMessage({ id: "common.password" })}
            placeholder={formatMessage({ id: "common.enterPassword" })}
          />
          <FormError />
          <FormikSubmitButton type="submit" className={classes.button} icon={EmailOutlinedIcon}>
            <FormattedMessage id="common.signIn" />
          </FormikSubmitButton>
        </Form>
      </Formik>
      <div className={classes.linkBlock}>
        <Link to={`/${locale}/recovery`} onClick={sendForgotClickEvent}>
          <FormattedMessage id="login.forgotPassword" />
        </Link>
        <div>
          <FormattedMessage id="login.noAccount" />
          <a href={getSignUpUrl(locale)} className={classes.signUpLink} onClick={sendSignUpClickEvent}>
            <FormattedMessage id="login.create" />
          </a>
        </div>
      </div>
    </Layout>
  );
};
